export const getContextNameFromUrlBasePath = () => {
  const url = new URL(window.location.href);
  const parts = url.pathname.split("/").filter(Boolean);
  return parts[0];
};
